import { connect } from 'react-redux'

import fetchSearchResults from '../../common/actions/searchPage'

const mapStateToProps = (state) => {
  const {
    results,
    loading,
    ingestedContent,
    relatedSearches,
    timeout,
    studioRecommendations,
    searchHeadings
  } = state.searchPage
  const {
    currentSite,
    baseUrl
  } = state.common
  const {
    user
  } = state
  return {
    results,
    loading,
    searchHeadings,
    studioRecommendations,
    ingestedContent,
    currentSite,
    relatedSearches,
    user,
    baseUrl,
    timeout
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

const createSearchPageContainer = (component) => {
  const container = connect(
    mapStateToProps,
    mapDispatchToProps
  )(component)

  container.loadData = (store, parsedUrl, opts) => {
    return store.dispatch(fetchSearchResults(parsedUrl, opts))
  }

  return container
}

export default createSearchPageContainer



// WEBPACK FOOTER //
// ./client/containers/searchPageContainer.js